import React from 'react';
import Button from '../../../components/ui/Button';

const ActionButtons = ({
  onDownloadReceipt,
  onEmailReceipt,
  onTrackOrder,
  onContinueShopping
}) => {
  return (
    <div className="bg-card rounded-xl shadow-warm border border-border p-6">
      <h3 className="font-heading font-bold text-lg text-foreground mb-4">
        What would you like to do next?
      </h3>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {/* Download Receipt */}
        <Button
          onClick={onDownloadReceipt}
          variant="outline"
          iconName="Download"
          iconPosition="left"
          fullWidth
        >
          Download Receipt
        </Button>

        {/* Email Receipt */}
        <Button
          onClick={onEmailReceipt}
          variant="outline"
          iconName="Mail"
          iconPosition="left"
          fullWidth
        >
          Email Receipt
        </Button>

        {/* Track Order */}
        <Button
          onClick={onTrackOrder}
          variant="default"
          iconName="MapPin"
          iconPosition="left"
          fullWidth
        >
          Track Order
        </Button>

        {/* Continue Shopping */}
        <Button
          onClick={onContinueShopping}
          variant="secondary"
          iconName="ShoppingBag"
          iconPosition="left"
          fullWidth
        >
          Continue Shopping
        </Button>
      </div>
    </div>
  );
};

export default ActionButtons;